Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.InvalidChartViewFactory
  canHandle: (widget) ->
    widget.get('type') == CustomerVisualMode.Charts.InvalidChartView.NAME

  create: (widget, data, isReadOnly, isResponsive) ->
    new CustomerVisualMode.Charts.InvalidChartView(widget, isResponsive, isReadOnly)

